import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router/index";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { Actions } from "@/store/enums/StoreEnums";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import "@/core/plugins/prismjs";
const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

// Attempt session restoration before mounting.
// The refresh token cookie (if valid) will be used to get a new access token.
// This prevents a flash of the sign-in page on page refresh.
const initApp = async () => {
  try {
    await store.dispatch("AuthModule/" + Actions.REFRESH_TOKEN);
  } catch {
    // Silent failure — router guard will redirect to sign-in if needed
  }
  app.mount("#app");
};

initApp();
